import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify.js'
import router from './routes/router'


Vue.config.productionTip = false
new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
